export default __webpack_public_path__ + "static/media/news1.b4103bf6.svg";